import React, { Component } from "react";
import { Row, Col } from "shards-react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Button, FormGroup, FormControl } from "react-bootstrap";
import feedbackService from "../../../../api/Feedback/FeedbackService";
export default class CreateFeedback extends Component {
  constructor(props) {
    super(props);

    this.state = {
      feedback: {
        id: null,
        reason_category: null,
        subject: null,
        message: null,
        employee_number: "000000",
        employee_name: "ADMIN",
      },
    };

    this.handleEvent = this.handleEvent.bind(this);
  }

  componentDidMount() {}

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.name !== this.state.name) {
      this.handler();
    }
  }

  componentWillUnmount() {}

  // Prototype methods, Bind in Constructor (ES2015)
  handleEvent() {}

  // Class Properties (Stage 3 Proposal)
  handler = () => {
    this.setState();
  };

  onCreateChange = (e) => {
    let feedback = this.state.feedback;
    feedback[e.target.name] = e.target.value;
    this.setState({ feedback });
  };

  onButtonClick = () => {
    feedbackService.addFeedback({
      reason_category: this.state.feedback.reason_category,
      subject: this.state.feedback.subject,
      message: this.state.feedback.message,
      employee_number: this.state.feedback.employee_number,
      employee_name: this.state.feedback.employee_name,
    });
    toast.success(`FeedBack Sent Successfully`, {
      position: toast.POSITION.TOP_CENTER,
    });
    this.setState({ category: { id: null, description: null } });
    document.getElementById("subject").value = "";
    document.getElementById("message").value = "";
    document.getElementById("reason_category").value = "#";
  };

  render() {
    return (
      <>
        <h5 className="m-0">Create Feedback</h5>
        <Row form>
          <Col md="6">
            <div className="form-group mt-2" id="role">
              <select
                class="form-control"
                id="reason_category"
                name="reason_category"
                onChange={this.onCreateChange.bind(this)}
              >
                <option value="#">Select Reason</option>
                <option value="application_issues">Application Issues</option>
                <option value="benefit_issues">Benefit Issues</option>
                <option value="employee_data_issues">
                  Employee Data Issues
                </option>
              </select>
            </div>
          </Col>
          <Col md="6" />
          <Col md="6" className="form-group">
            <FormGroup controlId="email" id="create-user">
              <label>Subject</label>
              <FormControl
                autoFocus
                type="text"
                name="subject"
                id="subject"
                onChange={this.onCreateChange.bind(this)}
              />
            </FormGroup>
          </Col>
          <Col md="6" />
          <Col md="6" className="form-group mt-4">
            <FormGroup controlId="email" id="create-user">
              <label>Message</label>
              <FormControl
                autoFocus
                as="textarea"
                rows={3}
                name="message"
                id="message"
                onChange={this.onCreateChange.bind(this)}
              />
            </FormGroup>
          </Col>
          <Col md="6" />
          <Col
            md="6"
            className="form-group pt-2 align-self-center"
            align="right"
          >
            <Button
              className="btn btn-dark text-white w-25"
              onClick={this.onButtonClick.bind(this)}
            >
              Create
            </Button>
          </Col>
        </Row>
      </>
    );
  }
}
